export const TabType = {
  OVERVIEW: `Overview`,
  DETAILS: `Details`,
  REVIEWS: `Reviews`
};

export const MOVIES_TO_SHOW = 8;

export const AppRoute = {
  ROOT: `/`,
  LOGIN: `/login`,
  MY_LIST: `/mylist`,
  MOVIE: `/films`,
  PLAYER: `/player`,
  REVIEW: `/review`,
};

export const MAX_RATING = 5;

export const MIN_PER_HOUR = 60;

export const VIDEO_PROGRESS = 100;

export const DEFAULT_VALUE = 5;

export const ReviewValue = {
  MIN_VALUE: 50,
  MAX_VALUE: 400,
};
